import GPSRecorder from './GPSRecorder';

export default GPSRecorder;
